export default __webpack_public_path__ + "static/media/phsa.2151d2cb.jpg";